import React, { Component } from 'react'
import ExperienceList from './ExperienceList/ExperienceList'

class Experience extends Component {
  render() {
    return (
      <div className="section" id="experience">
        <div className="container">
          <div className="col-md-12">
            <h4>02</h4>
            <h1 className="size-50">
              My <br />
              Experience
            </h1>
            <div className="h-50"></div>
          </div>

          <div className="col-md-12">
            <ExperienceList />
          </div>
        </div>
      </div>
    )
  }
}

export default Experience
